/** One ancestor of a menu, as far as placing it is concerned. */
export interface Box {
  /** Its computed overflow, both axes as the browser reports them ("visible", "hidden"…). */
  overflow: string;
  /** Its bottom edge on screen. */
  bottom: number;
}

/**
 * Whether a menu should open upwards: there is not room for it below its trigger inside the
 * nearest box that would cut it off, or inside the window.
 *
 * <p>Asked of every ancestor, not of a named one. It used to ask only the table's scroll box,
 * and the audit screen's category card — which hides what overflows, for its rounded corners —
 * cut the photo menu of a category's last question down to one item of four (test team,
 * 4 November).</p>
 */
export function opensUp(triggerBottom: number, menuHeight: number, ancestors: Box[], windowBottom: number): boolean {
  const clip = ancestors.find((box) => !/^(visible\s*)+$/.test(box.overflow.trim()));
  const bottom = Math.min(clip?.bottom ?? windowBottom, windowBottom);
  return bottom - triggerBottom < menuHeight + 8;
}
